import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { handleKeyDown2, verifyDateExpires, handleKeyDown, CODEMP_MUSIMUNDO } from '../utilities'
import { setFirstStep, setTitularData, setHomeData, setBeneficiaryData, setAdditionalData, setAllSteps, setCodpmpol, setCurrentTab, setGlobalTab, setPayMethod, setResetData, setCompletedPurchase, setErrorEncrypt, setStateNotebook, setFirstFormCompleted } from "../redux/reducer/stepReducer/stepReducer";
import { createErrorEmail, finishPurchase, savePayMethod } from "../redux/reducer/stepReducer/thunks";
import { url, params, options } from '../redux/reducer/stepReducer/thunks';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import FormHelperText from "@mui/material/FormHelperText";
import { FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import visacard from '../assets/visa.jpg'
import mastercard from '../assets/master.jpg'
import creditcard from '../assets/credito.jpg'
import Layout from "../components/Layout";
import Spinner from "../components/Spinner";
import * as openpgp from 'openpgp';


const helperStyles = {
  margin: 0,
  marginBottom: 14,
  marginTop: 2,
  position: "relative",
  left: "15px",
  letterSpacing: '0px',
};

const helperStyles2 = {
  margin: 16,
  marginBottom: 0,
  marginTop: 10,
  position: "relative",
  left: "-1px",
  letterSpacing: '0px'
};

const customStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '287px',
  bgcolor: '#ECE6F0',
  borderRadius: '20px',
  p: '16px',
};
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const FormPago = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, cards, codemp } = useSelector(state => state.adminReducer.login);
  const { completedPurchase, codpmpol, typeBeneficiary, firstStep, payMethod, titularData, homeData, beneficiaryData, paramsMus } = useSelector((state) => state.firstStep);
  const [isLoading, setIsLoading] = useState(false);
  const [check, setCheck] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [error, setError] = useState({
    creditCard: false,
    cardNumber: false,
    typeCard: false,
    fullName: false,
    dni: false,
    expires: false,
    check: false,
    otherErrorMsg: false,
    errorCard: false,
    errorDni: false,
    errorFullName: false,
  });

  const formContainerRef = useRef(null);
  const dniRef = useRef(null);
  const vencimientoRef = useRef(null);
  const creditCard = useRef(null);
  const cardNumber = useRef(null);
  const fullNameRef = useRef(null);

  const typeCards = cards?.filter((e) => e['cod-cia'] == firstStep.codcia && e['cod-sec'] == firstStep.codsec);

  const handleChange = (name, value) => {
    if (name === "expires") {
      // const valueOfExpiration = normalizeDate(value);
      dispatch(setPayMethod({ 'expires': value }));
    };
    if (name === "dni") {
      const valueOfDNI = value.substring(0, 8);
      dispatch(setPayMethod({ 'dni': valueOfDNI }));
      if (Number(value) < 0) {
        dispatch(setPayMethod({ 'dni': '' }));
      } else {
        dispatch(setPayMethod({ 'dni': value }));
      }
    }
    else dispatch(setPayMethod({ [name]: value }));
    setError({ ...error, [name]: false });
  };

  const handleCheck = () => {
    if (!check) setCheck(true);
    else setCheck(false);
  };

  const handleBack = () => {
    if (firstStep.codsec === '8') {
      dispatch(setCurrentTab(2));
      return navigate('/datosHogar');
    };
    if (firstStep.codsec === '12') {
      dispatch(setCurrentTab(2));
      dispatch(setGlobalTab(2.6));
      return typeBeneficiary == 'legal' ? navigate('/datosBeneficiario') : navigate('/detalleBeneficiario');
    };
    if (firstStep.codsec === '19' || firstStep.codsec === '62') {
      dispatch(setCurrentTab(2));
      dispatch(setFirstFormCompleted(true));
      return navigate('/datosTitular');
    }
    else if (firstStep.codsec === '159' || firstStep.codsec === '161') {
      dispatch(setCurrentTab(2));
      dispatch(setGlobalTab(2.6));
      return navigate('/datosTecnologia');
    }
  };

  const encryptPruCard = async (cardNumber) => {
    try {
      const publicArmoredKey = `-----BEGIN PGP PUBLIC KEY BLOCK-----

mQENBFiI8l0BCADIrK/m06Z8t7wG/i0qzYo7bIVH5mWDgN3+yrt9WXffeHFbyChr
AbX9Wfad0fcGahp2Y1FzaloqpakFCgL6fO7QpLb4hcyZAjwV8stJjZPiLN1OFI3o
4tKao6SqUJJyWYyGkkFg7Jci1cYBA7mGv1W2tw1FHEYc9ZOmNsstMvIWQ69XYfxE
o9eyKA+YKp4y6zM3kBShnXG1oCcQE0zs7Q4vLA6Cm1D2+PROyUSTc4MEt6JPqWvR
aIYj29+sLRPOxNcAUunwo0NPHH5G1WV4X4lfxUSwT+cbuqnC18+VR3mLcBVmdRUx
pFwWkQffh5zOrG7zZqPsv0cICAzlb/1z9uqZABEBAAG0HkdpcmVQQ0kgPGFibV9z
ZWdpbmZvQGdpcmUuY29tPokBOQQTAQgAIwUCWIjyXQIbAwcLCQgHAwIBBhUIAgkK
CwQWAgMBAh4BAheAAAoJEFofvXIt0fTu0MwH/RFBJQSMlI2Rt04cckXMVM++mwXL
SaWly668UiuwYO2eN/Sekvgyniw6lUDlmaC8ekC7+l3JOuYefizHjsvdW2xKg702
qs4G50MrQkhjl6mJhdGSSq2IpJmH61B1dXCFhBj5vb11Ej448vX4/yxkpt+1naIO
K2l2L5gqtl1tvfP75wJ03HTiaCwj2gNPjyQT9yYAgknoMLsBOwqd+jhXyjj1BQGx
P/BtnVIzq4AvB4IdDips1EejlQZbxRQKEFZDL15g4ckgoK9F9Zv6A/gOAf/WNpO5
FOM2DqLIgY8D1rL5TtO7TrfEVO2kbFj9VU4pDwYctddnY53NSM8jXYW70xi5AQ0E
WIjyXQEIAO478YDxDXjY9iYnBlRip1E684SPCO4ylPtLhsrkZpMVYelovxayV3x4
tyXE4dw4gmlVnQotuUux1GXfI65ytSUyeWUcXoGfB246Wx0ZmvVVcE5eATVkhuye
lA0wctOH2t0UW3Z3TxfGw698sy3KyCMh41wpj9HI4fLFUoIXpl7l+NKm9b0x1NKm
iGOP0AcTNQv8L4pj1Riba587vcm757946vpu7GDYyTneM4F+UY5gRaqSJImYRN/1
n7LFrMHoi7Cb2EW5kmUaDbLnHlaKmi6QIqq+paB0mp755nQRH3Qa1wkKjKGaqyfW
nE3IAKabJDYWngeG5/dj9zUuc6hNjrMAEQEAAYkBHwQYAQgACQUCWIjyXQIbDAAK
CRBaH71yLdH07pEUB/0b2e/YAEhZlHxJT1fvNDFvSb+Xb/bzuQJgsTB3Fy8rr/VT
SU6HADMdyQsftGA7e0cSin6wBegQsPE0eJvJwmXQuIJIiK/3nnuMdHGd57bL5kdt
UznRcLxbieAYWlV03T9+Y9k2DtKI4ZIKPaHg1OqfagPuQdryAaoBdFiCjuPGb7ug
hmmgB1BJJbfjCmvC42sRDwCTCzyc98v2mLv6EjG5GSllhKCiwbibbKZX6LZ+xYBo
YNjOMCTLs4ZRYIfNCu7MNhk2UkXba6F3obCRAN7JyijiunnZu7lvKJtknFY6WkMf
U1zUpjglkI9XwPzEcyP9Gt9sNhkl63z6WIFEoo6j
=5Z8U

-----END PGP PUBLIC KEY BLOCK-----`;
      const publicKey = await openpgp.readKey({ armoredKey: publicArmoredKey });

      const text = cardNumber.replaceAll(" ", "")

      const cryptOptions = {
        message: await openpgp.createMessage({ text }),
        encryptionKeys: publicKey,
      };

      const tarPGP = await openpgp.encrypt(cryptOptions);

      const regex = /-----BEGIN PGP MESSAGE-----\n([\s\S]+)\n=.*\n-----END PGP MESSAGE-----/;
      const coincidencias = tarPGP.match(regex);

      if (coincidencias && coincidencias.length >= 2) {
        const encryptedTar = coincidencias[1];
        return encryptedTar.trim().replace(/\n/g, '');
      }
    } catch (err) {
      // console.log(err);
    }
  };


  const validateTypeCard = async (cardNumber) => {
    const num = cardNumber.substring(0, 7).split(" ").join("");
    params.set('opcpm', 'binChecker');
    params.set('bin', num);
    setIsLoading(true);
    const response = await axios.post(url, params, options)
      .then(r => {
        // console.log(r.data)
        if (r.data?.isCredit) {
          setIsLoading(false);
          return true;
        }
        else {
          setIsLoading(false);
          return false;
        }
      })
      .catch((r) => {
        // console.log('error:', r);
        setIsLoading(false);
        return false;
      });
    return response;
  };

  const handleSubmit = async (e) => {
    if (!payMethod.dni) {
      setError({ ...error, dni: true })
      dniRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (payMethod.dni.length < 7 || payMethod.dni.length > 8) {
      setError({ ...error, errorDni: true })
      dniRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!payMethod.fullName) {
      setError({ ...error, fullName: true });
      formContainerRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (payMethod.fullName.length < 3 || payMethod.fullName.length > 70 || payMethod.fullName.split(' ').length < 2) {
      setError({ ...error, errorFullName: true });
      formContainerRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (/^\s|\s$/.test(payMethod.fullName)) {
      dispatch(setPayMethod({ 'fullName': payMethod.fullName.trim() }));
    }
    if (!payMethod.creditCard) {
      setError({ ...error, creditCard: true });
      creditCard.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!payMethod.cardNumber) {
      cardNumber.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      setError({ ...error, errorCard: true });
      return;
    }
    if (payMethod.cardNumber.length < 16 || /[!@#$%^&*(),.?":{}|<>;\-\+\/]/.test(payMethod.cardNumber)) {
      cardNumber.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      setError({ ...error, cardNumber: true })
      return;
    }
    if (payMethod.cardNumber[0] == "4" && (payMethod.creditCard == "MASTER" || payMethod.creditCard == "AMEX")) {
      cardNumber.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      setError({ ...error, typeCard: true });
      return;
    }
    if (payMethod.cardNumber[0] == "5" && (payMethod.creditCard == "AMEX" || payMethod.creditCard == "VISA")) {
      cardNumber.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      setError({ ...error, typeCard: true });
      return;
    }
    if (payMethod.cardNumber[0] == "3" && (payMethod.creditCard == "MASTER" || payMethod.creditCard == "VISA")) {
      cardNumber.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      setError({ ...error, typeCard: true });
      return;
    }
    if (payMethod.expires === "" || !payMethod.expires.includes("/") || payMethod.expires.length !== 5) {
      setError({ ...error, expires: true })
      return;
    }
    const typeCardisCredit = await validateTypeCard(payMethod.cardNumber);
    if (!typeCardisCredit) {
      setIsLoading(false);
      cardNumber.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      setError({ ...error, cardNumber: true })
      return;
    }
    const currentYear = new Date().getFullYear() % 100; // año actual.
    const currentMonth = new Date().getMonth() + 1; // mes actual 1 al 12 por eso se le suma 1.
    if (Number(payMethod.expires.substring(0, 2)) > 12 || Number(payMethod.expires.substring(0, 2)) < 1) {
      setError({ ...error, otherErrorMsg: true })
      return;
    }
    if (Number(payMethod.expires.substring(3, 5)) < currentYear || (Number(payMethod.expires.substring(0, 2)) < currentMonth && Number(payMethod.expires.substring(3, 5)) === currentYear)) {
      setError({ ...error, otherErrorMsg: true })
      return;
    }
    if (!check) {
      setError({ ...error, check: true })
      return;
    }
    let encryptedNumber = ""
    if (firstStep.codcia === 88) encryptedNumber = await encryptPruCard(payMethod.cardNumber)
    setIsLoading(true);
    const { price } = firstStep;
    if (encryptedNumber)
      await dispatch(savePayMethod({ ...payMethod, price, encryptedNumber }, codpmpol));
    else await dispatch(savePayMethod({ ...payMethod, price }, codpmpol));
    await dispatch(finishPurchase(user, codpmpol));
    setTimeout(() => { setIsLoading(false); }, 500);
    navigate("/confirmacion");
  };


  const handleOpenModal = () => {
    if (check) {
      setCheck(false);
      return;
    }
    else {
      setModalIsOpen(true);
      setError({ ...error, check: false });
    };
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };
  //////////

  useEffect(() => {
    if (!codpmpol) {
      try {
        const getLocalStorageCodpmpol = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
        const storageCodpmpol = getLocalStorageCodpmpol();
        if (Array.isArray(storageCodpmpol)) {
          let message = `Error Recid | FormPago | Intencion: ${firstStep.nro} | DNI TITULAR: ${titularData.dni} | NOMBRE TITULAR: ${titularData.name + ' ' + titularData.lastname}`
          dispatch(createErrorEmail(message));
          dispatch(setErrorEncrypt(true))
          navigate('/error');
        } else {
          dispatch(setCodpmpol(storageCodpmpol));
          const dataPayMethod = JSON.parse(localStorage.getItem("payMethod"));
          const dataFirststep = JSON.parse(localStorage.getItem("firstStep"));
          const dataTitularData = JSON.parse(localStorage.getItem("titularData"));
          if (localStorage.getItem("beneficiaryData")) {
            const dataBeneficiaryData = JSON.parse(localStorage.getItem("beneficiaryData"));
            dispatch(setBeneficiaryData({ ...beneficiaryData, ...dataBeneficiaryData }));
          }
          if (localStorage.getItem("homeData")) {
            const dataHomeData = JSON.parse(localStorage.getItem("homeData"));
            dispatch(setHomeData({ ...homeData, ...dataHomeData }));
          }
          if (localStorage.getItem("dataNotebook")) {
            const dataNotebook = JSON.parse(localStorage.getItem("dataNotebook"));
            dispatch(setStateNotebook({ ...dataNotebook }));
          }
          dispatch(setPayMethod({ ...payMethod, ...dataPayMethod }));
          dispatch(setFirstStep({ ...firstStep, ...dataFirststep }));
          dispatch(setTitularData({ ...titularData, ...dataTitularData }));
          handleChange('creditCard', dataPayMethod.creditCard);
        };
      } catch (error) {
        let message = `Error en Datos del Pago | ${error}`
        dispatch(createErrorEmail(message));
        dispatch(setErrorEncrypt(true))
        navigate('/error');
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("payMethod", JSON.stringify(payMethod));
  }, [payMethod]);
  //////////////
  useEffect(() => {
    setError({ ...error, 'expires': false, 'otherErrorMsg': false });
  }, [payMethod.expires]);


  useEffect(() => {
    setError({ ...error, 'cardNumber': false, 'errorCard': false });
  }, [payMethod.cardNumber]);

  useEffect(() => {
    setError({ ...error, 'creditCard': false, 'typeCard': false });
  }, [payMethod.creditCard]);

  useEffect(() => {
    setError({ ...error, 'dni': false, 'errorDni': false });
  }, [payMethod.dni]);

  useEffect(() => {
    setError({ ...error, 'fullName': false, 'errorFullName': false });
  }, [payMethod.fullName]);

  useEffect(() => {
    if (payMethod.expires !== "") {
      handleChange('expires', payMethod.expires);
    };
  }, []);

  /*useEffect(() => {
    if (payMethod.dni.length >= 8) {
      dniRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [payMethod.dni]);

  useEffect(() => {
    if (payMethod.fullName.length > 3 && payMethod.fullName.split(' ').length < 2) {
      dniRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [payMethod.fullName]);

  useEffect(() => {
    if (payMethod.creditCard) {
      fullNameRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [payMethod.creditCard]);

  useEffect(() => {
    if (payMethod.cardNumber.length >= 16) {
      creditCard.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [payMethod.cardNumber]);

  useEffect(() => {
    if (payMethod.expires.length >= 5) {
      vencimientoRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [payMethod.expires]);*/

  useEffect(() => {
    dispatch(setAllSteps(`payMethod-${firstStep.title}-${firstStep.plan}-${firstStep.codpro}`));
  }, []);

  useEffect(() => {
    dispatch(setAdditionalData('Información de pago'));

    return () => {
      dispatch(setAdditionalData(''));
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = 'Estoy a punto de refrescarme'; // Necesario para mostrar el mensaje de confirmación en algunos navegadores.
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    dispatch(setCurrentTab(3));
    dispatch(setGlobalTab(0));
  }, []);

  useEffect(() => {
    if (completedPurchase) {
      dispatch(setResetData());
      localStorage.removeItem("firstStep");
      localStorage.removeItem("titularData");
      localStorage.removeItem("homeData");
      localStorage.removeItem("payMethod");
      localStorage.removeItem("plan");
      localStorage.removeItem("insured");
      localStorage.removeItem("productType");
      if (firstStep.codsec == '12') {
        localStorage.removeItem("typeBeneficiary");
        localStorage.removeItem("completedCheck");
        localStorage.removeItem("expanded");
        localStorage.removeItem("beneficiaryData");
        localStorage.removeItem("checkedItems");
      }
      dispatch(setCompletedPurchase(false));
      navigate('/');
    } else return;
  }, []);

  useEffect(() => {
    if (Number(paramsMus.nro) === 0 || paramsMus.nro === "") {
      let message = `Error por N° Intención en Datos del pago | N° ${paramsMus}`
      dispatch(createErrorEmail(message));
      dispatch(setErrorEncrypt(true));
      navigate('/error');
    };
  });

  return (
    <div className='testdiv' >
      {
        isLoading ?
          <Spinner /> :
          <Layout>
            <div className="forms" >
              <p ref={dniRef}>Ingresá tus datos</p>
              <form onSubmit={handleSubmit} ref={formContainerRef}>
                <Box component="form" sx={{ "& > :not(style)": { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                  <TextField
                    error={error.dni || error.errorDni}
                    label="DNI Titular"
                    variant="outlined"
                    name='dni'
                    // ref={dniRef}
                    type="number"
                    onChange={({ target }) => {
                      let updatedValue = target.value;
                      updatedValue = updatedValue.replace(/\./g, '');
                      updatedValue = updatedValue.slice(0, 8);
                      handleChange('dni', updatedValue);
                    }}
                    onKeyDown={handleKeyDown}
                    value={payMethod.dni}
                    helperText={error.dni && 'DNI es requerido' || error.errorDni && 'DNI requiere 7 u 8 dígitos'}
                  />
                  {!error.dni && <FormHelperText style={helperStyles}>Titular de la tarjeta</FormHelperText>}
                </Box>
                <Box
                  component="form"
                  sx={{ "& > :not(style)": { m: 1, width: "30ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    label="Nombre y Apellido"
                    variant="outlined"
                    name='fullName'
                    ref={fullNameRef}
                    type="text"
                    onChange={({ target }) => {
                      let updatedValue = target.value;
                      updatedValue = updatedValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
                      updatedValue = updatedValue.slice(0, 70); // Limitar a 50 caracteres
                      handleChange('fullName', updatedValue);
                    }}
                    onKeyDown={handleKeyDown2}
                    error={error.fullName || error.errorFullName}
                    value={payMethod.fullName}
                    helperText={error.fullName && 'Nombre y apellido es requerido' || error.errorFullName && 'Coloque su nombre y apellido'}
                  />
                  {!error.fullName && <FormHelperText style={helperStyles}>Tal cual figura en la tarjeta</FormHelperText>}
                </Box>
                <FormControl sx={{ m: 1, width: "30ch" }} error={error.creditCard || error.typeCard}>
                  <InputLabel id="demo-simple-select-label">Tipo de tarjeta</InputLabel>
                  <Select
                    value={payMethod.creditCard}
                    ref={creditCard}
                    label="Tipo de tarjeta"
                    disabled={false}
                    name='creditCard'
                    // ref={provinceRef}
                    onChange={({ target }) => handleChange('creditCard', target.value)}
                  >
                    <MenuItem value={''}>Tipo de tarjeta de credito</MenuItem>
                    {
                      typeCards?.map((e) =>
                        <MenuItem value={e.value}>{e.label}</MenuItem>
                      )
                    }
                  </Select>
                  {error.creditCard && <FormHelperText>Seleccione un tipo de tarjeta</FormHelperText>}
                  {error.typeCard && <FormHelperText>Tipo de tarjeta incorrecto</FormHelperText>}
                </FormControl>
                <Box
                  component="form"
                  sx={{ "& > :not(style)": { m: 1, width: "30ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    onKeyDown={handleKeyDown}
                    label="Número de tarjeta"
                    variant="outlined"
                    name='cardNumber'
                    type="tel"
                    ref={cardNumber}
                    onChange={({ target }) => {
                      let updatedValue = target.value;
                      updatedValue = updatedValue.replace(/\s/g, "").match(/.{1,4}/g)?.join(" ").substring(0, 19) || "";
                      handleChange('cardNumber', updatedValue);
                    }}
                    error={error.cardNumber || error.errorCard}
                    helperText={error.cardNumber && 'Revise su tarjeta de crédito' || error.errorCard && 'Número de tarjeta es requerido'}
                    value={payMethod.cardNumber}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {
                            payMethod.cardNumber?.[0] == "4" && payMethod.cardNumber.length >= 4 ? <img style={{ width: '95%' }} src={visacard} alt="visalogovector" /> :
                              payMethod.cardNumber?.[0] == "5" && payMethod.cardNumber.length >= 4 ? <img style={{ width: '95%' }} src={mastercard} alt="masterlogovector" /> :
                                <img style={{ width: '95%' }} src={creditcard} alt="creditcardlogovector" />
                          }
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* {!error.cardNumber && <FormHelperText style={helperStyles}>Los dígitos del frente de tu tarjeta</FormHelperText>} */}
                </Box>
                <Box
                  component="form"
                  sx={{ "& > :not(style)": { m: 1, width: "30ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    inputRef={vencimientoRef}
                    label="Vencimiento"
                    variant="outlined"
                    value={payMethod.expires}
                    onKeyDown={handleKeyDown}
                    onChange={({ target }) => {
                      let updatedValue = target.value;
                      updatedValue = updatedValue.replace(/\D/g, "");
                      updatedValue = updatedValue.slice(0, 4);
                      if (updatedValue.length > 2) {
                        updatedValue = updatedValue.slice(0, 2) + "/" + updatedValue.slice(2);
                      }
                      handleChange("expires", updatedValue)
                    }}
                    error={error.expires || error.otherErrorMsg}
                    helperText={error.expires ? 'Fecha de expiración es requerida' : error.otherErrorMsg ? 'Verifique fecha de expiración' : ''}
                  />
                  {/* {!error.expires && <FormHelperText style={helperStyles}>Fecha de expiración de la tarjeta</FormHelperText>} */}
                </Box>
                <Box
                  component="form"
                  sx={{ "& > :not(style)": { m: 1, width: "30ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <TextField
                    value={`$ ${firstStep.price}`}
                    label="Precio mensual"
                    disabled
                    variant="outlined"
                    name='award'
                  />
                </Box>
                <div onClick={handleOpenModal} style={{ cursor: "pointer" }}>
                  <div
                    className="checkbox"
                    style={{ backgroundColor: "#ECE6F0", height: 100, borderBottom: '0.1px solid #00000033', borderRadius: "2px" }}
                  >
                    <div>
                      <p style={{ left: 11, position: 'relative' }}>
                        <h6>Términos y condiciones</h6>
                        He leído y aceptado los términos <br />y condiciones de
                        suscripción.
                      </p>
                    </div>
                    <Box sx={{ display: 'flex', position: 'relative', left: 22, top: -19 }}>
                      <FormControl
                        required
                        error={check}
                        component="fieldset"
                        sx={{ m: 3 }}
                        variant="standard"
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...label}
                                defaultChecked
                                name="check"
                                sx={{ "&.Mui-checked": { color: CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue" } }}
                                checked={check}
                                onChange={handleCheck}
                              />
                            }
                          />
                        </FormGroup>
                      </FormControl>
                    </Box>
                  </div>
                  {error.check && <FormHelperText style={{ color: 'red', textAlign: 'center' }}>Verifique términos y condiciones</FormHelperText>}
                </div>
              </form>
              <div className="contenedorBotones">
                <Stack spacing={1} direction="row" alignItems={'flex-end'}>
                  <Button style={{ borderRadius: 20, textTransform: "capitalize" }} size="medium" color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"} variant="outlined" onClick={handleBack} >Atrás</Button>
                  <Button
                    style={{ borderRadius: 20, textTransform: "capitalize" }}
                    size="medium"
                    color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                    variant="contained"
                    onClick={handleSubmit}
                  >
                    Contratar
                  </Button>
                </Stack>
              </div>
            </div>
            <Modal
              open={modalIsOpen}
              onClose={handleCloseModal}
              closeAfterTransition
            >
              <Fade in={modalIsOpen}>
                <Box sx={customStyles}>
                  <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                    Términos y condiciones
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto' }}>
                    Al aceptar "He leído y acepto los <br />
                    términos y condiciones", confirmas <br />
                    que se han leído, comprendido y estás <br />
                    de acuerdo con todas las disposiciones <br />
                    establecidas en las <b>condiciones <br />
                      específicas y generales de las <br />
                      coberturas disponibles.</b>
                  </Typography>
                  <div
                    className="contenedorBotones"
                    style={{
                      spacing: 9,
                      display: "flex",
                      flexDirection: "row",
                      margin: 13,
                      position: "relative",
                    }}
                  >
                    <Button
                      style={{ borderRadius: 20, textTransform: "capitalize", color: '#000' }}
                      size="medium"
                    >
                      <a target="_blank" rel="noreferrer" href={`https://www.platform.com.ar/terminos/terminos-${codemp < 50 ? codemp : (codemp - 50)}-${firstStep.codsec}-01-03-2024.pdf`}>
                        <label style={{ color: "black", cursor: "pointer" }}>Descargar</label>
                      </a>
                    </Button>
                    <Button
                      style={{ borderRadius: 20, textTransform: "capitalize" }}
                      size="medium"
                      color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                      variant="contained"
                      type="submit"
                      onClick={handleCloseModal}
                    >
                      Aceptar
                    </Button>
                  </div>
                </Box>
              </Fade>
            </Modal>
          </Layout>
      }
    </div>
  );
};

export default FormPago;
